import React from 'react';
import drivetrainImg from './Logos/Assets/Drivetrain.png';
import './Styles/Subsystems.css';

const DrivetrainPage = () => {
    return (
        <div className="subsystem-page">
            <h1>DriveTrain Subsystem</h1>
            <img src={drivetrainImg} alt="Drivetrain" className="subsystem-image" />
            <p>

                The DriveTrain team gives TONE the ability to move with speed, control, and confidence. Our focus is on making sure the robot can dodge, chase, and reposition at a moment’s notice. Every move in the arena depends on the drivetrain doing its job perfectly. Whether it’s lining up for a big hit or escaping danger, mobility is everything.
                <br /><br />
                We test different setups to make sure TONE can handle any situation. Quick turns, fast acceleration, and reliable traction are key to staying in the fight. A great drivetrain means we can outmaneuver the competition and stay one step ahead at all times.
            </p>
        </div>
    );
};

export default DrivetrainPage;